import { createFileRoute, Outlet } from "@tanstack/react-router";

// Developer settings (#638): a pathless layout, not a page of its own — it
// exists only so `developer/index.tsx`, `developer/access.tsx` and
// `developer/email.tsx` share the `/developer` URL prefix without one of them
// visually wrapping the others. Content for each lives entirely in the child
// route (#641/#642's job); this file renders no chrome.
// On `component: Outlet` rather than an inline arrow, see `posts.tsx`.
export const Route = createFileRoute("/dashboard/w/$workspaceId/developer")({
  component: Outlet,
});
